import { useLoginToggle } from "@/hooks";
import { useAuthContext } from "@/hooks/context-hooks";
import { Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import Dashboard from "./home/dashboard/dashboard";

export default function ProtectedRoute() {
  const { isAuth } = useAuthContext();
  const handleLoginToggle = useLoginToggle();
  const location = useLocation();

  useEffect(() => {
    if (!isAuth) {
      handleLoginToggle(true);
    }
  }, [location.pathname, isAuth]);


  if (isAuth) {
    return <Outlet />
  }
  return <Dashboard />
}